<template>
  <div
    class="columns"
    :class="classes">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    isMultiline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function () {
      const classes = []
      if (this.isMobile) {
        classes.push('is-mobile')
      }
      if (this.isMultiline) {
        classes.push('is-multiline')
      }
      return classes
    }
  }
}
</script>
